import type { TweetResponseMediaItemDimensions } from './tweetResponseMediaItemDimensions';
import type { TweetResponseMediaItemType } from './tweetResponseMediaItemType';

export type TweetResponseMediaItem = {
  dimensions?: TweetResponseMediaItemDimensions;
  id: string;
  mimeType?: string;
  size?: number;
  thumbnailUrl?: string;
  type: TweetResponseMediaItemType;
  url: string;
};
